import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './Mortgage.css';

interface IMortgageProps {
  title: React.ReactNode;
  calculator: React.ReactNode;
}

export function Mortgage({ title, calculator }: IMortgageProps) {
  return (
    <section className={styles['container']}>
      <Layout>
        <div className={styles['wrapper']}>
          <div className={styles['title']}>{title}</div>
          {calculator}
        </div>
      </Layout>
    </section>
  );
}
